import Vue           from 'vue';
import App           from './App.vue';
import router        from './router';
import store         from './store';
import Common        from '@/utils/common.js';
import Md5           from '@/utils/Md5.min.js';
import deviceMixin   from '@/mixins/deviceMixin.js';
import VueI18n       from 'vue-i18n';
import messages      from './lang/index.js';
import VueLazyload   from 'vue-lazyload';
import ElementUI     from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/rem.js';
import 'animate.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.mixin(deviceMixin);

// import errorImg      from '@/../public/static/imgs/error.png';  // 图片加载失败时的占位图像
// import loadingImg    from '@/../public/static/imgs/loading.gif';// 图片加载时的占位图像
// import '@fortawesome/fontawesome-free/css/all.css';
// import 'lib-flexible';

Vue.config.productionTip = false;
Vue.prototype.$Common    = Common;
Vue.prototype.$Md5       = Md5;
// Vue.prototype.$lazyload  = VueLazyload;

Vue.use(ElementUI);
// 多语言
Vue.use(VueI18n);
const i18n = new VueI18n({  
	locale: 'cn',// 默认语言
	messages
});

// 预加载
const errorimage = require('./assets/static/imgs/common/error.png');
const loadimage  = require('./assets/static/imgs/common/loading.gif');
Vue.use(VueLazyload, {
	preLoad     : 1.3,         // 预加载的高度比例
	error       : errorimage,  // 加载失败时显示的图片
	loading     : loadimage,   // 加载中显示的图片
	attempt     : 1            // 尝试加载次数
	// listenEvents: ['scroll']// 监听的事件类型
});

// 自定义指令，懒加载背景图片
Vue.directive('lazy-background', {
	// 当绑定元素插入到DOM中
	inserted(el, binding) {
		if (binding.value) {
			// 设置元素的背景图
			el.style.backgroundImage = `url('${binding.value}')`;
			el.style.backgroundSize  = '100px 100px';
			// 初始化VueLazyload实例
			const lazyLoadInstance   = Vue.prototype.$lazyload;
			// 使用VueLazyload的方法监听元素
			lazyLoadInstance.addListener(el, binding.value);
		}
	}
});

new Vue({
	router,
	store,
	i18n, // 将 i18n 配置到 Vue 实例中
	render: h => h(App)
}).$mount('#app');
